module.exports = __webpack_public_path__ + "img/y_2007_1.f1577b02.png";